import { AutocompleteField} from '@src/corelib/forms/generic';
import { useAbsenceTypes } from '@src/query';

export default function ReasonField() {
  const { data } = useAbsenceTypes();
  const options = data ? data.map((item) => ({label: item.acty_name, value: item.id})) : [];
  return <AutocompleteField label="Reason" name="acti_type" sx={StyleSheet.reason} options={options} />;
}
const StyleSheet = {
  reason: {
    '.MuiFormLabel-root': {
      top: '20px',
    },
  },
};
